export const openMenuAboveMeta = (opts: { index: number; total: number }) => {
  return {
    openMenuAbove: Math.max(10, opts.total) - opts.index <= 3,
  };
};
